var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 9.86989V11.6199V11.6199C12.836 12.2642 12.3158 12.7887 11.6715 12.7913C11.6349 12.7914 11.5982 12.7899 11.5617 12.7866H11.5617C9.76673 12.5915 8.04249 11.9781 6.52757 10.9957H6.52758C5.11814 10.1001 3.92319 8.90516 3.02758 7.49573L3.02758 7.49573C2.04173 5.97393 1.42822 4.24131 1.23674 2.43823V2.43823C1.17875 1.79651 1.65195 1.22929 2.29367 1.1713C2.32822 1.16817 2.36289 1.16659 2.39758 1.16656H4.14758V1.16656C4.73316 1.1608 5.23229 1.59004 5.31425 2.16989V2.16989C5.38811 2.72993 5.52509 3.27982 5.72258 3.80906V3.80906C5.88284 4.2354 5.78034 4.71603 5.46008 5.03989L4.71925 5.78073V5.78073C5.54966 7.24113 6.75884 8.45032 8.21925 9.28073L8.96008 8.53989V8.53989C9.28394 8.21963 9.76457 8.11713 10.1909 8.27739V8.27739C10.7202 8.47488 11.27 8.61186 11.8301 8.68573V8.68573C12.4167 8.76848 12.8481 9.27769 12.8334 9.86989L12.8334 9.86989Z",
    stroke: "#767C8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotline);
export default __webpack_public_path__ + "static/media/hotline.f32e79d846c26c70a238803986ed6410.svg";
export { ForwardRef as ReactComponent };